import { BasicPrivateOfferVO } from "./BasicPrivateOfferVO";
/**
 * Created with IntelliJ IDEA.
 * User: ffischer
 * Date: 10.04.13
 * Time: 11:58
 */

import Event = createjs.Event;

export class PrivateOfferDataEvent extends Event {
    public static PRIVATE_OFFER_CREATED: string = "PRIVATE_OFFER_CREATED";
    public static PRIVATE_OFFER_REMOVED: string = "PRIVATE_OFFER_REMOVED";
    public static PRIVATE_OFFER_STATE_CHANGED: string = "PRIVATE_OFFER_STATE_CHANGED";

    public offerVO: BasicPrivateOfferVO;

    constructor(type: string, offerVO: BasicPrivateOfferVO, bubbles: boolean = true, cancelable: boolean = false) {
        super(type, bubbles, cancelable);
        this.offerVO = offerVO;
    }
}

